<template>
  <v-overlay :value="loading" color="grey lighten-1" absolute>
    <v-progress-circular indeterminate size="32"></v-progress-circular>
  </v-overlay>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
